import { InjectionToken } from "@angular/core";
import { NavigationMenuEntry } from "./navigation-menu-entry.interface";

export interface NavigationConfig {
    menuItems: NavigationMenuEntry[];
}

export const NAV_CONFIG = new InjectionToken<NavigationConfig[]>('NAV_CONFIG');